export interface ConsentDetails {
  consent: {
    type: 'EXPLICIT' | 'IMPLICIT';
    updatedAt: number;
  };
  categories?: {
    functional?: {
      state: 'ALL_ACCEPTED' | 'ALL_DENIED' | 'PARTIALLY_ACCEPTED';
    };
    marketing?: {
      state: 'ALL_ACCEPTED' | 'ALL_DENIED' | 'PARTIALLY_ACCEPTED';
    };
    essential?: {
      state: 'ALL_ACCEPTED' | 'ALL_DENIED' | 'PARTIALLY_ACCEPTED';
    };
  };
}

export interface ConsentCookie {
  product: boolean;
  marketing: boolean;
  necessary: boolean;
}

export const defaultConsent: ConsentCookie = {
  product: false,
  marketing: false,
  necessary: true,
};
